export default __webpack_public_path__ + "static/media/(4).87c06e1e.jpeg";